module.exports = __webpack_public_path__ + "static/media/logo-color-2.d689e842.png";